export default [{
  state: 'communicationTools',
  config: {
    url: '/communication-tools/:categoryId',
    component: 'communicationToolList',
  },
}, {
  state: 'communicationToolCollection',
  config: {
    url: '/communication-tool/:categoryId/:collectionId',
    component: 'communicationToolCollection',
  },
}, {
  state: 'communicationToolDetail',
  config: {
    url: '/communication-tool/:categoryId/:collectionId/:itemId',
    component: 'communicationToolDetail',
  },
}];



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool.routes.js